<template>
  <q-page>
    <partner-header>
      <div class="container">
        <div class="row q-mx-sm">
          <div class="col-12 col-md-8">
            <h1 class="title">{{ content.h1 }}</h1>
            <p class="subtitle">{{ content.subtitle }}</p>
            <header-text />
          </div>
          <div class="col-12 col-md-4">
            <partner-form ref="partnerForm" />
          </div>
        </div>
      </div>
    </partner-header>
    <section class="about container text-center">
      <div class="row">
        <div
          v-for="item in content.about"
          :key="item.header"
          class="col-12 col-md q-pa-lg"
        >
          <h1>{{ item.header }}</h1>
          <h2>{{ item.text }}</h2>
        </div>
      </div>
    </section>
    <section class="advantages container">
      <h1 class="q-pb-xl q-px-md text-center">{{ content.best_prices }}</h1>
      <div class="row list">
        <div
          v-for="(value, key) in content.advantages"
          :key="key"
          class="col-6 col-md-3 q-px-lg q-py-md"
        >
          <q-icon
            :name="`img:img/agent/${key}.svg`"
            size="50px"
          />
          <h2 class="text-bold">{{ value.header }}</h2>
          <p class="text-grey">{{ value.text }}</p>
        </div>
      </div>
    </section>
    <section class="why-us container text-center">
      <h1 class="q-pb-xl">{{ content.why_us }}</h1>
      <div class="row">
        <div
          v-for="(value, key) in content.reasons"
          :key="key"
          class="col-12 col-sm-6 col-md-3 q-pa-lg"
        >
          <q-icon
            :name="`img:img/agent/${key}.svg`"
            size="50px"
          />
          <h2>{{ value }}</h2>
        </div>
      </div>
    </section>
    <section class="feedback container">
      <h1 class="text-center">{{ $t('label.feedback') }}</h1>
      <partner-feedback />
    </section>
    <section class="join text-center">
      <q-btn
        class="btn-shadow text-bold"
        color="positive"
        @click="$refs.partnerForm.showModal()"
      >
        <div class="btn-label fs-16">{{ $t('pages.for_business.join_us') }}</div>
      </q-btn>
    </section>
    <section class="partners container">
      <h1 class="q-pb-lg text-center">{{ content.trusted }}</h1>
      <partnership />
    </section>
  </q-page>
</template>

<script>
import PartnerForm from 'components/partner_new/Form';
import Partnership from 'components/partner_new/Partnership';
import PartnerHeader from 'components/partner_new/Header';
import HeaderText from 'components/partner_new/HeaderText';
import PartnerFeedback from 'components/partner_new/Feedback';

export default {
  name: 'AgentNew',
  components: {
    PartnerForm,
    Partnership,
    PartnerHeader,
    HeaderText,
    PartnerFeedback,
  },
  preFetch({
    redirect, store, currentRoute, ssrContext, urlPath,
  }) {
    const { configs, accessPartnerNewPage } = store.getters;

    if (accessPartnerNewPage) {
      if (ssrContext.themeName) {
        redirect(`${configs.base_url}${urlPath}`);
      }
      return;
    }

    redirect(`/${currentRoute.params.locale}/client/`);
  },
  computed: {
    content() {
      return this.$t('pages.for_agents');
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 42px;
  font-weight: bold;
  margin: 0;

  @media (max-width: $breakpoint-xs-max) {
    font-size: 24px;
  }
}

h2 {
  font-size: 18px;

  @media (max-width: $breakpoint-xs-max) {
    font-size: 16px;
  }
}

.title {
  text-align: center;

  @media (min-width: $breakpoint-md-min) {
    text-align: left;
    padding-left: 24px;
    padding-top: 80px;
  }
}

.subtitle {
  font-size: 20px;
  font-weight: normal;
  text-align: center;
  padding-bottom: 26px;
  padding-top: 12px;

  @media (min-width: $breakpoint-md-min) {
    font-size: 26px;
    font-weight: bold;
    text-align: left;
    padding-left: 24px;
    padding-top: 0;
  }
}

.text-grey {
  font-size: 16px;
  color: rgba(0, 0, 0, .55);

  @media (max-width: $breakpoint-xs-max) {
    font-size: 14px;
  }
}

.about {
  padding-top: 80px;
}

.advantages {
  padding: 80px 16px 0 16px;

  .list {
    text-align: left;
    @media (max-width: $breakpoint-sm-max) and (min-width: $breakpoint-sm-min) {
      text-align: center;
    }
    @media (max-width: $breakpoint-xs-max) {
      padding-left: 8px;
    }
  }
}

.why-us {
  padding: 80px 32px 0 32px;
}

.feedback {
  padding-top: 80px;
}

.join {
  margin: 80px 0;
}

.partners {
  padding: 30px 0;
}

.btn {
  &-label {
    padding: 16px 32px;
  }

  &-shadow {
    box-shadow: 0 2px 24px hsla(0, 0%, 45.5%, .5);
  }
}

::v-deep .partner-form {
  @media (max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {
    width: 320px;
  }
}

::v-deep .title-block {
  @media (min-width: $breakpoint-md-min) {
    &--body {
      font-size: 22px;
      letter-spacing: 2px;
    }
    &--header {
      font-size: 12px;
      letter-spacing: 2px;
    }
  }
  @media (min-width: $breakpoint-lg-min) {
    &--body {
      letter-spacing: 4px;
    }
    &--header {
      font-size: 14px;
      letter-spacing: 4px;
    }
  }
}
</style>
